var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAddIconBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13434",
    "data-name": "Rectangle 13434",
    width: 24,
    height: 23,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_640",
    "data-name": "Line 640",
    d: "M16,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H16a1,1,0,0,1,1,1A1,1,0,0,1,16,1Z",
    transform: "translate(4.5 11.977)",
    fill: "#f7f8f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_641",
    "data-name": "Line 641",
    d: "M0,17a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V16A1,1,0,0,1,0,17Z",
    transform: "translate(12.5 3.917)",
    fill: "#f7f8f9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAddIconBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_add_icon_big.c0cb37e96bdcebfc89b4932487775bd9.svg";